'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */

import { FC } from 'react';
import { FeLink } from '../../../components/FeLink';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { NavigationItemLevel3 } from '../types';
import { navbarLinkToUrl } from '../utils/utils';

interface NavItemProps {
  index: number;
  sectionTitle: string;
  pushDataLayer: PushDataLayerFn;
}

const SidebarLink: FC<NavItemProps & NavigationItemLevel3> = (props) => {
  const { langPrefix, brand } = useCmsClientContext();
  const { index, sectionTitle, pushDataLayer, ...link } = props;
  const { text, href, url_target } = navbarLinkToUrl(link, {
    langPrefix,
    brand,
  });

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
    pushDataLayer({
      event: 'navigate',
      component_type: 'top-nav',
      component_title: `Level 3_${sectionTitle}/${text}`,
      action: 'click',
      index,
    });
  };

  return (
    <div className="border-b-2 border-[#D0E8FE] px-2 py-5 text-[#687076] text-[16px]">
      <FeLink
        href={href}
        target={url_target}
        className="flex items-center"
        onClick={handleClick}
      >
        {text}
      </FeLink>
    </div>
  );
};

export default SidebarLink;
